export const AUTOMATION_SETTINGS_TOOLBAR_TITLE = "Automation Settings";

export const OPTIONS = [
    { id: "1", label: "1 Month" },
    { id: "3", label: "3 Months" },
];

export const INTRO = "All calculations are going to be converted to the currency of the marketplace."
export const REFERRAL_FEE_INFO =  "Referral fee is calculated as a percentage of selling price"
export const OTHER_COSTS_INFO_PART1 = "Other costs are calculated as either a percentage of selling price or a fixed amount and assumed to be the currency of the marketplace"
export const PRODUCT_COST_AVERAGE_INFO_PART1 = "Product cost is calculated automatically as an average based on invoices over the date range specified."
export const PRODUCT_COST_AVERAGE_INFO_PART2 = "Product cost will be converted to the currency of the marketplace"
export const PRICE_INFO = "Price is in the currency of the marketplace"
export const SHIPPING_COST_INFO = "Shipping cost will be converted to currency of the marketplace if required"
export const BOX_COST_INFO_PART1 = "Box cost is calculated automatically as an average based on invoices over the date range specified."
export const BOX_COST_INFO_PART2 = "Box cost will be converted to the currency of the marketplace"
export const FTL_COST_PART1 = "FTL cost is calculated automatically as an average based on invoices over the date range specified."
export const FTL_COST_PART2 = "FTL cost will be converted to the currency of the marketplace"
export const CURRENCY = [
    { code: 'USD', name: 'US Dollar' },
    { code: 'EUR', name: 'Euro' },
    { code: 'JPY', name: 'Japanese Yen' },
    { code: 'GBP', name: 'British Pound' },
    { code: 'AUD', name: 'Australian Dollar' },
    { code: 'CAD', name: 'Canadian Dollar' },
    { code: 'CHF', name: 'Swiss Franc' },
    { code: 'CNY', name: 'Chinese Yuan' },
    { code: 'SEK', name: 'Swedish Krona' },
    { code: 'NZD', name: 'New Zealand Dollar' }
]

export const IN_USE_CURRENCIES = [
    { code: 'USD', name: 'USD' },
    { code: 'CAD', name: 'CAD' },
]